<template>
  <div>
    <a
      href="#"
      :class="data.enabled ? '' : 'disabled'"
      @click="click"
    >
      {{ grapesJSInstance === null ? 'Copy' : 'Select' }}
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  inject: ['onClick'],
  data () {
    return {
      data: {}
    }
  },
  computed: {
    ...mapGetters({
      grapesJSInstance: 'getGrapesJSInstance',
      dynamicContent: 'getDynamicContent'
    })
  },
  methods: {
    click (e) {
      e.preventDefault()
      const { enabled, link } = this.data
      if (enabled) {
        if (link) {
          if (link.resultType === 'Url') {
            this.onClick(link.url, 'link')
          } else {
            this.onClick(link.html, 'tag')
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  color: $gray-medium;
}
</style>
